import {Button} from "antd";
import {FileOutlined,} from "@ant-design/icons"
type Props={
    handleDelete:Function,
    handleChangeName:Function,
    fileNumber:string,
    alias:string,
}
const FileCard=(props:Props)=>{
    const {handleChangeName,alias,fileNumber,handleDelete}=props;
    return <div className="w-full p-3  border-gray-100 border-2 relative rounded bg-gray-50   rounded-lg">
        <div className="absolute -top-2 -right-2 w-[25px] h-[25px] flex justify-center items-center bg-gray-200 rounded-full">
            <FileOutlined twoToneColor="#fff" className="text-white" />
        </div>
        <div className="mx-3 pb-3 border-b border-dashed flex flex-col">  <strong>{alias}</strong>  <span>{fileNumber}</span></div>
        <div className="w-full flex flex-wrap mt-3 gap-3">
            <Button onClick={()=>{handleChangeName(fileNumber,alias)}} size="small" type="ghost" className="">تغییر نام مستعار</Button>
            <Button onClick={()=>{handleDelete(fileNumber)}} type="ghost" size="small"  className="text-red-400" danger>حذف </Button>
        </div>
    </div>
}
export default FileCard;